
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype4On as ObiMosfetNtype4OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-4-on.js';
 
 
 

 
 export const ObiMosfetNtype4On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-4-on',
   elementClass: ObiMosfetNtype4OnElement,
   events: {
     
   }
  });
 
 